// extracted by mini-css-extract-plugin
module.exports = {"btn":"TrialDirectPosterButton_btn__3WFAB","bottom":"TrialDirectPosterButton_bottom__3XBec","item":"TrialDirectPosterButton_item__7hEi-"};